import clsx from "clsx";
import { generatPropsTagA } from "./generatPropsTagA";
import styles from "./menuItem.module.scss";
import type { IMenu } from "../../../../constants";

interface MenuItemProps {
  menuItem: IMenu;
  onClick?: () => void;
  onCloseDrawer?: () => void;
  className?: string;
}
const MenuItem = (props: MenuItemProps) => {
  const { menuItem, onClick, onCloseDrawer, className } = props;
  const propTagA = generatPropsTagA(menuItem, onClick, onCloseDrawer);
  return (
    <div className={styles["menu-item"]} id="MenuItem">
      {propTagA.href ? (
        <a {...propTagA}>
          <span className={clsx(styles["menu-item__value"], className)}>
            {menuItem?.title}
          </span>
        </a>
      ) : (
        <span className={clsx(styles["menu-item__value"], className)}>
          {menuItem?.title}
        </span>
      )}
    </div>
  );
};

export default MenuItem;
